import React from 'react';
import { Link } from 'react-router';
import { connect } from 'react-redux';

const DocumentHeader = ({ document: { loading, error, data, metadata: { title, type, fileName } } }) => (
  <div className="doc-header">
    <div className="doc-header-content">
      <div className="type">
        {type && <span className={`ic ic-2x ic-${type.toLowerCase()}`}/>}
        {title}
      </div>
      <div className="right-content">
        {!loading && !error && data && (
          <a href={data} download={fileName}><span className="ic ic-download"/></a>
        )}
        <Link to="/"><span className="ic ic-close"/></Link>
      </div>
    </div>
  </div>
);

const mapStateToProps = ({ document }) => ({ document });

export default connect(mapStateToProps)(DocumentHeader);



// WEBPACK FOOTER //
// ./book/src/document/DocumentHeader.jsx